import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ContactType } from '@app/contacts/models/contact';
import { VoicemailService } from '@app/voicemail/services/voicemail.service';

@Component({
  selector: 'app-forward-voice-mail-dialog',
  templateUrl: './forward-voice-mail-dialog.component.html',
  styleUrls: ['./forward-voice-mail-dialog.component.scss'],
})
export class ForwardVoiceMailDialogComponent {
  protected isProcessing = false;
  protected selectedExt = '';

  protected readonly ContactType = ContactType;

  constructor(
    private dialogRef: MatDialogRef<ForwardVoiceMailDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
    private voicemailService: VoicemailService
  ) {}

  protected setSelectedExtension($event: string | undefined) {
    if (!$event) {
      return;
    }
    this.selectedExt = $event;
  }

  protected async forward() {
    try {
      this.isProcessing = true;

      await this.voicemailService.forwardVoicemail(this.data.id, this.selectedExt);
    } catch (error) {
      console.error('Error while forwarding voicemail:', error);
    } finally {
      this.isProcessing = false;
      this.closeDialog();
    }
  }

  protected closeDialog() {
    this.dialogRef.close();
  }

  protected handleClickOnForward($event: string) {
    this.setSelectedExtension($event);
    this.forward();
  }
}
